import type { TransactionKind } from "../types"

export const collectionLabels: Record<TransactionKind, string> = {
  EXPENSE: "Gasto",
  INCOME: "Ingreso",
  SAVING: "Ahorro",
  TRANSFER: "Transferencia",
}

